import { createUseStyles } from 'react-jss';
import { Spacings } from '../../../../foundation/spacings/spacings/index.js';
import { CornerRadius } from '../../../../foundation/cornerRadius/cornerRadius/index.js';
import { Shadows } from '../../../../foundation/colors/shadows/shadows/index.js';
import { ControlBorderColors } from '../../../../foundation/colors/controlBorderColors/controlBorderColors/index.js';
import { NegativeColors } from '../../../../foundation/colors/negativeColors/negativeColors/index.js';

const useStyles = createUseStyles({
    root: {
        '--arrow-width': '24px',
        '--arrow-height': '24px',
        '--arrow-gap': '-19px',
        '--bg-color': NegativeColors.base.default,
        '--border-color': ControlBorderColors.default,
        backgroundColor: 'var(--bg-color)',
        boxShadow: Shadows.tint1,
        border: '2px solid var(--border-color)',
        borderRadius: CornerRadius.r4,
        wordBreak: 'break-word',
        zIndex: (props) => props.zIndex,
        pointerEvents: ({ notClickable }) => notClickable && 'none',
    },
    content: {
        padding: [Spacings.s6, Spacings.s10],
    },
    indicatorWrapper: {
        width: 'var(--arrow-width)',
        height: 'var(--arrow-height)',
        '& svg': {
            transform: 'translateY(-0.0125em)',
        },
        '&[data-arrow-wrapper-dir^="top"]': {
            bottom: 'var(--arrow-gap)',
        },
        '&[data-arrow-wrapper-dir^="right"]': {
            left: 'var(--arrow-gap)',
            '& svg': {
                transform: 'translateY(-0.0125em) rotate(90deg)',
            },
        },
        '&[data-arrow-wrapper-dir^="bottom"]': {
            top: 'var(--arrow-gap)',
            '& svg': {
                transform: 'translateY(-0.0125em) scaleY(-1)',
            },
        },
        '&[data-arrow-wrapper-dir^="left"]': {
            right: 'var(--arrow-gap)',
            '& svg': {
                transform: 'translateY(-0.0125em) rotate(-90deg)',
            },
        },
    },
    indicator: {
        borderWidth: '0 5px 0 5px',
        width: 'var(--arrow-width)',
        height: 'var(--arrow-height)',
        pointerEvents: 'none',
        '& path': {
            fill: 'var(--bg-color)',
        },
    },
}, {
    name: 'tooltip',
});

export { useStyles };
